// extracted by mini-css-extract-plugin
export default {"title":"TopTitle_title__QTxT+"};